module.exports = __webpack_public_path__ + "img/uncheckedbox.b9ef5f36.svg";